// src/app/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { sanitizeCompanyLogoUrl } from '../functions/companyLogoUrl';
import { resolveBackUrl } from '../utils/backUrl';

// The player's data is saved in sessionStorage at login (localStorage was read here before, which is never
// written, so nothing was restored after a refresh - including where Back goes).
function readPersistedUser() {
  try {
    return JSON.parse(sessionStorage.getItem('userData') || localStorage.getItem('userData') || 'null');
  } catch {
    return null;
  }
}
const persistedUser = readPersistedUser();
const initialState = {
  companyLogoUrl: sanitizeCompanyLogoUrl(persistedUser?.companyLogoUrl ?? null),
  backButtonUrl: persistedUser ? resolveBackUrl(persistedUser) : null,
  /** True while /main shows a day sub-view (not the stage grid). */
  mainDaySubViewOpen: false,
  /** Incremented when header Back should return to the main grid; MainPage listens and clears the day view. */
  mainGridBackNonce: 0,
  /** When true, the header Back button is hidden (e.g. on /canvas-reveal). */
  backButtonHidden: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setCompanyLogoUrl(state, action) {
      state.companyLogoUrl = sanitizeCompanyLogoUrl(action.payload ?? null);
    },
    setBackButtonUrl(state, action) {
      state.backButtonUrl = action.payload;
    },
    setMainDaySubViewOpen(state, action) {
      state.mainDaySubViewOpen = !!action.payload;
    },
    requestBackToMainGrid(state) {
      state.mainGridBackNonce += 1;
    },
    setBackButtonHidden(state, action) {
      state.backButtonHidden = !!action.payload;
    },
  },
});

export const {
  setCompanyLogoUrl,
  setBackButtonUrl,
  setMainDaySubViewOpen,
  requestBackToMainGrid,
  setBackButtonHidden,
} = uiSlice.actions;
export default uiSlice.reducer;
